<template>
	<div>
		<div class="top">
			<div class="top-item w">
				<div class="top-left" v-text="common_info.store.name+'，欢迎您'" v-if="common_info.store.name">
					<!-- <img class="img-default" src="../../assets/images/address.png" alt /> 北京 -->
				</div>
				<ul class="top-right">
					<!-- 未登录 -->
					<li class="login" v-if="login">
						<router-link to="/signin" class="ttshop_lodings">您好，请登录</router-link>
						<router-link to="/register">免费注册</router-link>
					</li>
					<!-- 已登录 -->
					<li class="logings" v-else>
						<p>欢迎您，<router-link to="/ttshop_user" v-text="user.nickname"></router-link> <strong @click="signout()">退出</strong></p>
					</li>
					<li class="top_last" @click="mydingdan()">
						我的订单
						<!-- <img class="img-default xia xiaimg" src="../../assets/images/top_xia.png" alt /> -->
					</li>
					<li class="top_last" @click="toPersonal()">
						个人中心
						<!-- <img class="img-default xia xiaimg" src="../../assets/images/top_xia.png" alt /> -->
					</li>
					<!-- <li class="top_last top_lasteders" @click="gocart()">
						<img class="img-default cat" src="../../assets/images/cat1.svg" alt /> 购物车
					</li> -->
					<template v-if="bb_show">
						<li class="top_last top_lasteders" @click="merchant()" v-if="common_info.mch_url">入驻商登录</li>
					</template>
					
					<li class="top_last top_lasted" v-if="common_info.QrCode && common_info.QrCode.length">
						移动端
						<img class="img-default xia" src="../../assets/images/top_xia.png" alt />
						<div class="phone-code">
							<template v-for="(item,index) in common_info.QrCode">
								<img class="img-default" :src="item" alt="">
							</template>
						</div>
					</li>
					<li class="top_last top_lasted">
						商家支持
						<!-- <img class="img-default xia" src="../../assets/images/top_xia.png" alt /> -->
					</li>
					<li class="top_last" v-if="bb_show">
						<router-link to="/apply?mch_type=1">申请入驻</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import App from '../../App.vue';
	export default {
		data() {
			return {
				user: "",
				login: true,
				common_info: {
					store: {
						search_hot_content: {}
					},
					QrCode: []
				},
				bb_show:false,
			};
		},
		created() {
			this.common.loginType(this);
			this.common.getCommonInfo(this);
		},
		mounted(){
			var that=this;
			if(sessionStorage.getItem("appStore")){
				let appStore=JSON.parse(sessionStorage.getItem("appStore"));
				for(let i in appStore.permission_list){
					if(appStore.permission_list[i]=='b2b2c'){
						that.bb_show=true
					}
				}
			}
		},
		methods: {
			// 我的订单
			mydingdan() {
				if(this.login){
					this.$router.push("/signin");
				}else{
					this.$router.push("/ttshop_usermyorder");
				}
			},
			// 个人中心
			toPersonal() {
				this.common.toPersonal(this);
			},
			//退出
			signout() {
				this.common.signout(this);
			},
			// 入驻商跳转
			merchant() {
				window.open(this.common_info.mch_url)
			},
			phoneCode(){
				console.log(11)
			}
		},
	};
</script>

<style lang="scss" scoped>
	.top {
		width: 100%;
		height: 32px;
		background-color: #f5f5f5;
		color: #666666;

		.top-item {
			height: 32px;
			display: flex;

			.top-left {
				height: 32px;
				display: flex;
				align-items: center;

				img {
					height: 12px;
					width: 12px;
				}
			}

			.top-right {
				margin-left: auto;
				display: flex;
				height: 32px;
				align-items: center;

				.xia {
					height: 12px;
					width: 12px;
					display: block;
				}

				.cat {
					height: 12px;
					width: 12px;
					display: block;
					margin-right: 4px;
				}

				li {
					height: 32px;
					display: flex;
					padding: 0 12px;
					align-items: center;
					box-sizing: border-box;
					cursor: pointer;
					position: relative;

					&::before {
						content: "";
						width: 1px;
						height: 10px;
						background: #d9d9d9;
						position: absolute;
						top: 12px;
						right: 0px;
					}

					&:last-child::before {
						display: none;
					}

					>a {
						cursor: pointer;
						color: #ff0e25;
						text-decoration: none;
						outline: 0;

						&:first-child {
							margin-right: 16px;
						}
					}
				}

				.top_last {
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;
					position: relative;
					a{
						margin-right: 0 !important;
						transition: 0.5s;
						-moz-transition: 0.5s;
						-webkit-transition: 0.5s;
						-o-transition: 0.5s;
						color: #333;
					}
					&:hover {
						background-color: #fff;
						a{
							color: #ff0e25;
						}
						.phone-code{
							visibility: visible;
							opacity: 1;
						}
					}
					.phone-code{
						visibility: hidden;
						opacity: 0;
						background: #fff;
						padding: 0 10px 10px 10px;
						border: 1px solid #f5f5f5;
						border-top: 0;
						position: absolute;
						top: 32px;
						left: -1px;
						z-index: 999;
						display: flex;
						flex-wrap: wrap;
						width: 260px;
						img{
							// width: 80px;
							// height: 80px;
							width: 120px;
							height: 120px;
							margin: 10px 10px 0 0;
						}
						img:nth-child(3n){
							margin-right: 0;
						}
					}
					
				}

				.login {
					.ttshop_lodings {
						font-size: 12px;
						color: #999;
						margin-right: 8px;
						transition: 0.5s;
						-moz-transition: 0.5s;
						-webkit-transition: 0.5s;
						-o-transition: 0.5s;
						cursor: pointer;

						&:hover {
							color: #ff0e25;
						}
					}
				}

				.logings {
					p {
						font-size: 12px;
						color: #999;

						a {
							font-size: 12px;
							color: #ff0e25;
						}

						strong {
							margin-left: 2px;
							font-size: 12px;
							color: #999;
							font-weight: 500;
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;
							cursor: pointer;

							&:hover {
								color: #ff0e25;
							}
						}
					}
				}
			}
		}
	}
</style>
